module.exports = __webpack_public_path__ + "img/audio.39fa6af9.jpg";